module.exports = function($) {
  if ($.inviewport) {
    return;
  }
  $.belowthefold = function(element, settings) {
    var fold;
    fold = $(window).height() + $(window).scrollTop();
    return fold <= $(element).offset().top - settings.threshold;
  };
  $.abovethetop = function(element, settings) {
    var top;
    top = $(window).scrollTop();
    return top >= $(element).offset().top + $(element).height() - settings.threshold;
  };
  $.rightofscreen = function(element, settings) {
    var fold;
    fold = $(window).width() + $(window).scrollLeft();
    return fold <= $(element).offset().left - settings.threshold;
  };
  $.leftofscreen = function(element, settings) {
    var left;
    left = $(window).scrollLeft();
    return left >= $(element).offset().left + $(element).width() - settings.threshold;
  };
  $.inviewport = function(element, settings) {
    return !$.rightofscreen(element, settings) && !$.leftofscreen(element, settings) && !$.belowthefold(element, settings) && !$.abovethetop(element, settings);
  };
  $.extend($.expr[':'], {
    "below-the-fold": function(a, i, m) {
      return $.belowthefold(a, {
        threshold: 0
      });
    },
    "above-the-top": function(a, i, m) {
      return $.abovethetop(a, {
        threshold: 0
      });
    },
    "left-of-screen": function(a, i, m) {
      return $.leftofscreen(a, {
        threshold: 0
      });
    },
    "right-of-screen": function(a, i, m) {
      return $.rightofscreen(a, {
        threshold: 0
      });
    },
    "in-viewport": function(a, i, m) {
      return $.inviewport(a, {
        threshold: 0
      });
    }
  });

  /*
   * jQuery function to retrieve all classes from a selector
   *
   * @mixin jQuery.fn.getClasses
   * @returns {Array} classlist
   *
   * @example
   * $(document.body).getClasses()
   */
  jQuery.fn.getClasses = function() {
    var ca, classlist;
    ca = this.attr('class');
    classlist = [];
    if (ca && ca.length && ca.split) {
      ca = jQuery.trim(ca);
      ca = ca.replace(/\s+/g, ' ');
      classlist = ca.split(' ');
    }
    return classlist;
  };
  return jQuery.fn.getEvents = function(n) {
    if (n == null) {
      n = 0;
    }
    return $._data($(this)[n], 'events');
  };
};

//# sourceMappingURL=data:application/json;base64,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
